module.exports = function($) {
  if ($.inviewport) {
    return;
  }
  $.belowthefold = function(element, settings) {
    var fold;
    fold = $(window).height() + $(window).scrollTop();
    return fold <= $(element).offset().top - settings.threshold;
  };
  $.abovethetop = function(element, settings) {
    var top;
    top = $(window).scrollTop();
    return top >= $(element).offset().top + $(element).height() - settings.threshold;
  };
  $.rightofscreen = function(element, settings) {
    var fold;
    fold = $(window).width() + $(window).scrollLeft();
    return fold <= $(element).offset().left - settings.threshold;
  };
  $.leftofscreen = function(element, settings) {
    var left;
    left = $(window).scrollLeft();
    return left >= $(element).offset().left + $(element).width() - settings.threshold;
  };
  $.inviewport = function(element, settings) {
    return !$.rightofscreen(element, settings) && !$.leftofscreen(element, settings) && !$.belowthefold(element, settings) && !$.abovethetop(element, settings);
  };
  $.extend($.expr[':'], {
    "below-the-fold": function(a, i, m) {
      return $.belowthefold(a, {
        threshold: 0
      });
    },
    "above-the-top": function(a, i, m) {
      return $.abovethetop(a, {
        threshold: 0
      });
    },
    "left-of-screen": function(a, i, m) {
      return $.leftofscreen(a, {
        threshold: 0
      });
    },
    "right-of-screen": function(a, i, m) {
      return $.rightofscreen(a, {
        threshold: 0
      });
    },
    "in-viewport": function(a, i, m) {
      return $.inviewport(a, {
        threshold: 0
      });
    }
  });

  /*
   * jQuery function to retrieve all classes from a selector
   *
   * @mixin jQuery.fn.getClasses
   * @returns {Array} classlist
   *
   * @example
   * $(document.body).getClasses()
   */
  jQuery.fn.getClasses = function() {
    var ca, classlist;
    ca = this.attr('class');
    classlist = [];
    if (ca && ca.length && ca.split) {
      ca = jQuery.trim(ca);
      ca = ca.replace(/\s+/g, ' ');
      classlist = ca.split(' ');
    }
    return classlist;
  };
  return jQuery.fn.getEvents = function(n) {
    if (n == null) {
      n = 0;
    }
    return $._data($(this)[n], 'events');
  };
};

//# sourceMappingURL=data:application/json;base64,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
